module.exports = function($) {
  if ($.inviewport) {
    return;
  }
  $.belowthefold = function(element, settings) {
    var fold;
    fold = $(window).height() + $(window).scrollTop();
    return fold <= $(element).offset().top - settings.threshold;
  };
  $.abovethetop = function(element, settings) {
    var top;
    top = $(window).scrollTop();
    return top >= $(element).offset().top + $(element).height() - settings.threshold;
  };
  $.rightofscreen = function(element, settings) {
    var fold;
    fold = $(window).width() + $(window).scrollLeft();
    return fold <= $(element).offset().left - settings.threshold;
  };
  $.leftofscreen = function(element, settings) {
    var left;
    left = $(window).scrollLeft();
    return left >= $(element).offset().left + $(element).width() - settings.threshold;
  };
  $.inviewport = function(element, settings) {
    return !$.rightofscreen(element, settings) && !$.leftofscreen(element, settings) && !$.belowthefold(element, settings) && !$.abovethetop(element, settings);
  };
  $.extend($.expr[':'], {
    "below-the-fold": function(a, i, m) {
      return $.belowthefold(a, {
        threshold: 0
      });
    },
    "above-the-top": function(a, i, m) {
      return $.abovethetop(a, {
        threshold: 0
      });
    },
    "left-of-screen": function(a, i, m) {
      return $.leftofscreen(a, {
        threshold: 0
      });
    },
    "right-of-screen": function(a, i, m) {
      return $.rightofscreen(a, {
        threshold: 0
      });
    },
    "in-viewport": function(a, i, m) {
      return $.inviewport(a, {
        threshold: 0
      });
    }
  });

  /*
   * jQuery function to retrieve all classes from a selector
   *
   * @mixin jQuery.fn.getClasses
   * @returns {Array} classlist
   *
   * @example
   * $(document.body).getClasses()
   */
  jQuery.fn.getClasses = function() {
    var ca, classlist;
    ca = this.attr('class');
    classlist = [];
    if (ca && ca.length && ca.split) {
      ca = jQuery.trim(ca);
      ca = ca.replace(/\s+/g, ' ');
      classlist = ca.split(' ');
    }
    return classlist;
  };
  return jQuery.fn.getEvents = function(n) {
    if (n == null) {
      n = 0;
    }
    return $._data($(this)[n], 'events');
  };
};

//# sourceMappingURL=data:application/json;base64,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
